module.exports = __webpack_public_path__ + "static/img/account-settings.057141ff.svg";